"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuestionManager = void 0;
// vendors
const React = __importStar(require("react"));
// utilities
const hooks_1 = require("../../hooks");
// constants
const FIRST_QUESTION_ID = 0;
// types
const types_1 = require("./types");
const useQuestionManager = (checkKycState, dataSource) => {
    const [questionIds, setQuestionIds] = React.useState([]);
    const [answers, setAnswers] = React.useState([]);
    const [question, setQuestion] = React.useState({});
    const questionId = React.useRef(FIRST_QUESTION_ID);
    const removeQuestionsAfterSelectedOne = (selectedQuestionId) => {
        const index = questionIds.indexOf(selectedQuestionId);
        const existQuestionId = index >= 0;
        if (existQuestionId) {
            setQuestionIds(questionIdList => [...questionIdList.slice(0, index + 1)]);
            setAnswers(answerList => [...answerList.slice(0, index)]);
        }
    };
    const setFieldError = () => {
        checkKycState(types_1.KycStatuses.QUESTION_ERROR);
    };
    // first question management
    const { call: getFirstQuestionCall, isLoading: isLoadingGetFirstQuestion, isError: hasErrorGetFirstQuestion, data: firstQuestion, } = (0, hooks_1.useAsyncStateInfo)(dataSource.getFirstQuestion);
    const getFirstQuestion = async () => {
        checkKycState(types_1.KycStatuses.LOADING_FIRST_QUESTION);
        await getFirstQuestionCall().then(({ data, error }) => {
            if (data) {
                checkKycState(types_1.KycStatuses.FIRST_QUESTION_LOADED);
                setQuestion(data);
                setQuestionIds([questionId.current]);
            }
            else if (error) {
                checkKycState(types_1.KycStatuses.LOADING_QUESTION_ERROR_STATUS);
            }
        });
    };
    // new questions management
    const { call: sendAnswerCall, isLoading: isLoadingSendAnswer, isError: hasErrorSendAnswer, data: newQuestion, reset: resetAnswer, } = (0, hooks_1.useAsyncStateInfo)(dataSource.sendAnswer);
    const sendAnswer = async (id, answerList) => {
        questionId.current = id;
        removeQuestionsAfterSelectedOne(id);
        setAnswers(currentAnswers => [...currentAnswers, { id, answers: answerList }]);
        checkKycState(types_1.KycStatuses.LOADING_QUESTION_STATUS);
        resetAnswer();
        await sendAnswerCall(answerList);
    };
    React.useEffect(() => {
        if (newQuestion) {
            checkKycState(types_1.KycStatuses.QUESTION_LOADED_STATUS);
            const isFormCompleted = newQuestion?.form?.formCompleted;
            if (isFormCompleted) {
                checkKycState(types_1.KycStatuses.FINISH_STATUS);
            }
            else {
                setQuestion(newQuestion);
                setQuestionIds(currentQpuestionIds => [...currentQpuestionIds, questionId.current + 1]);
            }
        }
    }, [newQuestion?.questions?.length]);
    React.useEffect(() => {
        if (hasErrorSendAnswer) {
            checkKycState(types_1.KycStatuses.LOADING_QUESTION_ERROR_STATUS);
        }
    }, [hasErrorSendAnswer]);
    // submit form management
    const { call: submitFormCall, isSuccess: isSuccessSubmitForm, isError: hasErrorSubmitForm, isSuccess, } = (0, hooks_1.useAsyncStateInfo)(dataSource.submitForm);
    const submitForm = async () => {
        checkKycState(types_1.KycStatuses.LOADING_SUBMIT_STATUS);
        return submitFormCall();
    };
    React.useEffect(() => {
        if (isSuccess) {
            checkKycState(types_1.KycStatuses.SUCCESS_STATUS);
        }
    }, [isSuccess]);
    React.useEffect(() => {
        if (hasErrorSubmitForm) {
            checkKycState(types_1.KycStatuses.ERROR_STATUS);
        }
    }, [hasErrorSubmitForm]);
    const resetForm = () => {
        setQuestionIds([]);
        setQuestion({});
        questionId.current = FIRST_QUESTION_ID;
    };
    return {
        questionIds,
        answers,
        question,
        isLoadingGetFirstQuestion,
        hasErrorGetFirstQuestion,
        isLoadingSendAnswer,
        hasErrorSendAnswer,
        isSuccessSubmitForm,
        hasErrorSubmitForm,
        setQuestionIds,
        setQuestion,
        removeQuestionsAfterSelectedOne,
        getFirstQuestion,
        sendAnswer,
        submitForm,
        resetForm,
        setFieldError,
    };
};
exports.useQuestionManager = useQuestionManager;
//# sourceMappingURL=useQuestionManager.hook.js.map